// endpoints which require dynamically fetched/cached query params
export function getDynamicEndpoint(params) {
  const getUserUUID = localStorage.getItem('user_uuid');

  return {
    update_user_profile: `v1/user/${getUserUUID}/profile`,
    user_collections: `v1/user/${getUserUUID}/collections`,
    user_teams: `v1/user/${getUserUUID}/teams`,
    add_team: `v1/user/${getUserUUID}/team`,
    delete_team: 'v1/team',
    generate_api_token: `v1/user/${getUserUUID}/profile/api_credential`,
    delete_api_token: `v1/user/${getUserUUID}/profile/api_credential`,
    resend_invite_user: `v1/invite/${params}/resend`,
    collection_seeds: `v1/collection/${params}/seeds`,
    add_collection_seed: `v1/collection/${params}/entities`,
    ticketing_providers: `v1/collection/${params}/ticketing_providers`,
  };
}

// endpoints which are pre-defined
export default {
  issues: 'library/issues',
  issueStats: 'library/issues/stats',
  issueDetails: 'library/issues/',
  technologies: 'library/fingerprints',
  technology_stats: 'library/fingerprints/stats',
  token: `v1/user/token`,
  profile: 'v1/user/profile',
  delete_team: 'v1/team',
  send_invite_user: 'v1/team/',
  cancel_invite_user: 'v1/invite/',
  get_integrations: 'library/tasks',
  get_integrations_stats: 'library/tasks/stats',
  get_entity: 'v1/entity/',
  collection: 'v1/collection/',
  get_collection_schedule: 'v1/collection/',
  get_collection_export: 'v1/collection/',
  get_collection_list: 'v1/user/collections',
  create_new_collection: 'v1/collection',
  system_metadata: 'v1/system/metadata',
};
